import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import CustomButton from "../../components/CustomButton";
import '../../assets/css/SubscriptionPlan.css';
import { useNavigate } from "react-router-dom";
import { MdStarRate } from "react-icons/md";
import { apiHandler } from '../../assets/api';
import { endpoint } from '../../assets/api/endpoint';
import { toast } from 'react-toastify';
import { useSelector } from "react-redux";

const SubscriptionPlan = () => {
  const [selectedPlan, setSelectedPlan] = useState("");
  const [plans, setPlans] = useState([]);
  const navigate = useNavigate();
  const { accessToken } = useSelector((state) => state?.loginInfo.accessToken);
  const filterId = plans?.filter((item) => item.name == selectedPlan)[0]?.id;
  const onNavigateButton = async () => {
    try {
      let result;
      if (selectedPlan.toLowerCase() === 'monthly') {
        result = await apiHandler({
          url: `${endpoint.SUBSCRIPTION_PAYMENT_API}?id=${filterId}`,
          method: "POST",
          authToken: accessToken,
        });
      } else if (selectedPlan.toLowerCase() === 'payasyougo') {
        result = await apiHandler({
          url: `${endpoint.ANOTHER_PAYMENT_API}?id=${filterId}`,
          method: "POST",
          authToken: accessToken,
        });
      } else {
        toast.error("Invalid filter ID.");
        return;
      }

      if (result?.data) {
        navigate("/stripe-payment", {
          state: {
            clientSecret: result.data.clientSecret,
            key: result.data.key,
            paymentIntentId: result.data.paymentIntentId,
            isSetupIntent: true
          }
        });
      }

    } catch (error) {
      console.error("API call failed:", error);
      toast.error("An error occurred while processing the payment.");
    }
  };

  const onSkipButton = () => {
    navigate('/explore');
  };

  useEffect(() => {
    const subscriptionPlan = async () => {
      try {
        const result = await apiHandler({
          url: endpoint.SUBSCRIPTION_PLAN,
          method: "GET",
          authToken: accessToken
        });

        const fetchedPlans = result?.data || [];
        if (fetchedPlans.length > 0) {
          setSelectedPlan(fetchedPlans[0]?.name);
        }

        setPlans(fetchedPlans);
      } catch (error) {
        toast.error(error.response?.data?.message || error.message || "An unexpected error occurred.");
      }
    };
    subscriptionPlan();
  }, []);

  return (
    <div className="d-flex justify-content-center align-items-center" style={{height: '100vh'}}>
      <div style={{ width: '50%' }}>
        <h3 className="mb-3">Choose your subscription plan</h3>
        <p className="text-muted mb-4">And get a 7-day free trial</p>
        <div className="mb-4">
          {plans?.map((plan) => (
            <div
              key={plan.id}
              style={{ cursor: "pointer", padding: '7px', margin: '7px' }}
              className={`card ${selectedPlan === plan.name ? "border-primary bg-light" : ""}`}
              onClick={() => setSelectedPlan(plan.name)}
            >
              <div className="d-flex align-items-center justify-content-between">
                <div>
                  <input
                    type="radio"
                    name="plan"
                    id={plan.name}
                    checked={selectedPlan === plan.name}
                    onChange={() => setSelectedPlan(plan.name)}
                  />
                  <label
                    htmlFor={plan.name}
                    className="ms-2 fw-bold"
                    style={{ cursor: "pointer" }}
                  >
                    {plan.name}
                  </label>
                </div>
                <div>
                  <h5 className="m-0">${plan.price}</h5>
                  <small className="text-muted">{plan.count} users</small>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mb-4 p-3 bg-light rounded text-left">
          <h5 className="fw-bold d-inline-block">You'll get:</h5>
          <ul className="list-unstyled text-start">
            {plans?.find(p => p.name === selectedPlan)
              ?.planDetails?.details?.map((item, idx) => (
                <li key={idx} className="d-flex align-items-center pb-1">
                  <MdStarRate />
                  <span className="ps-1">{item}</span>
                </li>
              ))
            }
          </ul>
        </div>

        <div className="mb-3" onClick={onSkipButton}>
          <CustomButton
            buttonText={'Skip'}
            className='border'
            style={{
              width: '100%',
              height: '48px',
              borderRadius: '12px',
              background: '#6c757d',
              color: '#FFFFFF'
            }}
          />
        </div>

        <div onClick={onNavigateButton}>
          <CustomButton
            buttonText={'Next'}
            className='border'
            style={{
              width: '100%',
              height: '48px',
              borderRadius: '12px',
              background: '#006FFD',
              color: '#FFFFFF'
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default SubscriptionPlan;
